<template>
  <header id="header" class="header">
    <!-- Logo Start -->
    <div class="header__logo">
      <img src="../assets/img/logo.png" alt="Marvio - Coming Soon & Portfolio Template" />
    </div>
    <!-- Logo End -->

    <!-- Header Content Start -->
    <div class="header__content fullheight-mobile d-flex align-items-center">
      <div class="container-fluid px-0">
        <div class="row gx-0 justify-content-end justify-content-xl-start">
          <div class="col-auto col-xl-8">
            <!-- Header Controls Block Start -->
            <div
              class="
                header__buttons
                d-flex
                justify-content-end
                align-items-center
              "
            >
              <!-- Socials Desktop Start -->
              <div class="socials-desktop">
                <ul>
                  <li>
                    <a href="https://www.facebook.com/" target="_blank">
                      <i class="fa-brands fa-facebook"></i>
                    </a>
                  </li>
                  <li>
                    <a href="https://www.instagram.com/" target="_blank">
                      <i class="fa-brands fa-instagram"></i>
                    </a>
                  </li>
                  <li>
                    <a href="https://www.pinterest.com/" target="_blank">
                      <i class="fa-brands fa-pinterest"></i>
                    </a>
                  </li>
                  <li>
                    <a href="https://www.behance.net/" target="_blank">
                      <i class="fa-brands fa-behance"></i>
                    </a>
                  </li>
                  <li>
                    <a href="https://twitter.com/" target="_blank">
                      <i class="fa-brands fa-twitter"></i>
                    </a>
                  </li>
                  <li>
                    <a href="https://dribbble.com/" target="_blank">
                      <i class="fa-brands fa-dribbble"></i>
                    </a>
                  </li>
                </ul>
              </div>
              <!-- Socials Desktop End -->

              <!-- Notify Trigger Start -->
              <a
                id="notify-trigger"
                class="
                  btn-round-mobile btn-notify btn-light-outline
                  notify-trigger
                  hover-white hover-white-s
                "
                href="#0"
              >
                <em></em>
                <i class="fa-solid fa-bell"></i>
                <span class="btn-caption">Notify Me</span>
              </a>
              <!-- Notify Trigger End -->
            </div>
            <!-- Header Controls Block End -->
          </div>
          <div class="col-auto col-xl-4">
            <!-- Menu Trigger Start -->
            <div class="header__menu d-flex justify-content-end">
              <a id="menu-trigger" class="menu-trigger" href="#0">
                <span class="menu-objects"></span>
              </a>
            </div>
            <!-- Menu Trigger End -->
          </div>
        </div>
      </div>
    </div>
    <!-- Header Content End -->
  </header>
</template>

<script>
export default {
  name: "HeaderComponent",
};
</script>